export const POST_LOGOUT_WATCHER = 'POST_LOGOUT_WATCHER';
export const POST_LOGOUT_SUCCESS = 'POST_LOGOUT_SUCCESS';
export const POST_LOGOUT_FAILED = 'POST_LOGOUT_FAILED';
